












import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import ColorPicker from './components/ColorPicker.vue';

@Component({
  components: {
    ColorPicker,
  },
})
export default class App extends Vue {

  color: string | null = null;

  created() {
    this.color = '#00ff00';
  }

  get colors() {
    return [
      '#ff0000',
      '#00ff00',
      '#0000ff',
    ];
  }
}
